import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { Application } from '../../../enums/application.enums';

@Pipe({
  name: 'formatTime'
})
export class TimerFormat implements PipeTransform {
  transform(value: number): string {
    const minutes: number = Math.floor(
      (value %
        (Application.TWELVE * Application.THREE * Application.ONE_HUNDRED)) /
        Application.SIXTY
    );
    const seconds =
      Math.floor(value - minutes * Application.SIXTY).toString().length ===
      Application.ONE
        ? `0${Math.floor(value - minutes * Application.SIXTY)
            .toString()
            .slice(-Application.TWO)}`
        : Math.floor(value - minutes * Application.SIXTY)
            .toString()
            .slice(-Application.TWO);
    return `${minutes.toString().slice(-Application.TWO)}:${seconds}`;
  }
}

@Pipe({
  name: 'userTimeZone'
})
export class UserTimeZone implements PipeTransform {
  transform(value): string {
    if (value) {
      return moment.utc(new Date(value).getTime()).format();
    }
  }
}
